const stickycat = () => {

    var stickycat = $('.stickycat');
    if( $(window).scrollTop() >= 126 && stickycat.length == 1 ) {
        stickycat.addClass('sticky fadeInDown');
    }else if( $(window).scrollTop() < 70 && stickycat.length == 1 ){
        stickycat.removeClass('sticky fadeInDown');
    }
    
 }

 module.exports = {
    stickycat, 
 };

